<template>
  <div v-html="decodedHtml"></div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const decodedHtml = computed(() => {
  if (!props.content) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = props.content;
  return textarea.value;
});
</script>
